module.exports = __webpack_public_path__ + "img/trust-w.f40b4fde.svg";